function buildPathWithFile (basePath, selectedFile) {
    const filesIndex = basePath.indexOf('/files/');
    if (filesIndex !== -1) {
        basePath = basePath.substring(0, filesIndex);
    }
    // remove trailing slash if present
    if (basePath.endsWith('/')) {
        basePath = basePath.slice(0, -1);
    }

    if (!selectedFile || selectedFile === '') {
        return basePath;
    }

    return `${basePath}/files/${selectedFile}`;
}

document.addEventListener('DOMContentLoaded', function () {
    const tabIdLinks = document.querySelectorAll('[data-tab-id]');

    tabIdLinks.forEach(function (tabLink) {
        tabLink.addEventListener('click', function (event) {
            const tabName = this.dataset.tabId;
            const tabToDisplay = document.querySelector('[data-bs-target="#' + tabName + '"]');

            if (tabToDisplay) {
                const tab = new bootstrap.Tab(tabToDisplay);
                tab.show();
            }

            event.preventDefault();
        });
    });

    // Size the files tab iframe to fill remaining viewport height
    let filesIframe = document.querySelector('#files_tab iframe');

    function sizeFilesIframe() {
        if (filesIframe) {
            let top = filesIframe.getBoundingClientRect().top;
            filesIframe.style.height = (window.innerHeight - top) + 'px';
        }
    }

    if (filesIframe) {
        document.addEventListener('shown.bs.tab', function (event) {
            if (event.target.getAttribute('data-bs-target') === '#files_tab') {
                sizeFilesIframe();
            }
        });

        window.addEventListener('resize', function () {
            if (document.querySelector('#files_tab.show.active')) {
                sizeFilesIframe();
            }
        });

        // Size on load if files tab is already active
        if (document.querySelector('#files_tab.show.active')) {
            sizeFilesIframe();
        }
    }

    const filesTab = document.querySelector('[data-bs-target="#files_tab"]');
    if (filesTab) {
        const addOnIdentifier = filesTab.dataset.addOnIdentifier;

        if (typeof MW.postmessagechannel.PostMessageChannel !== undefined) {
            const viewerChannel = new MW.postmessagechannel.PostMessageChannel(window, '__linkclk__');
            viewerChannel.listen();
            const containedAddOnMap = new Set();

            viewerChannel.on('copyAction', function (message) {
                const selectedFile = message.body.filePath;
                if (selectedFile) {
                    if (containedAddOnMap.has(selectedFile)) {
                        return;
                    }
                    containedAddOnMap.add(selectedFile);
                    const requestData = {
                        file_path: selectedFile,
                        add_on_uuid: addOnIdentifier
                    };
                    const csrfToken = document.querySelector('meta[name=csrf-token]');

                    fetch(`${window.location.origin}/matlabcentral/fileexchange/copy_logging`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': csrfToken.getAttribute('content')
                        },
                        body: JSON.stringify(requestData)
                    })
                    .catch(error => {
                        console.error(error);
                    });
                }
            });

            // Extract initial file from URL if present
            const initialPath = window.location.pathname;
            const filesMatch = initialPath.match(/\/files\/(.+)$/);
            const initialFile = filesMatch ? filesMatch[1] : null;

            // Set initial state so back button works properly
            if (!window.history.state) {
                window.history.replaceState({ filePath: initialFile }, '', window.location.href);
            }

            viewerChannel.on('fileSelection', function (message) {
                const selectedFile = message.body.filePath;

                if (selectedFile) {
                    // ensure file tab is active
                    if (!filesTab.classList.contains('active')) {
                        const tab = new bootstrap.Tab(filesTab);
                        tab.show();
                    }

                    // Don't push duplicate state
                    if (window.history.state && window.history.state.filePath === selectedFile) {
                        return;
                    }

                    // Update the viewer_link anchor element
                    const viewerLink = document.getElementById('viewer_link');
                    if (viewerLink) {
                        const viewerUrl = new URL(viewerLink.href);
                        viewerUrl.pathname = buildPathWithFile(viewerUrl.pathname, selectedFile);
                        viewerLink.href = viewerUrl.toString();
                    }
                }

                // update URL in address bar
                const updatedPath = buildPathWithFile(window.location.pathname, selectedFile);
                const newUrl = `${updatedPath}${window.location.search}`;

                window.history.replaceState({ filePath: selectedFile }, '', newUrl);
            });
        }
    }
});

// JS to Sync Desktop/Mobile Changes Across Menus
// This handles a special use case for tabs that link to separate pages (rather than
// displaying content on the same page). Since this functionality is app-specific,
// it's not included in the template - only guidelines are provided in the components.
// See: https://bs5-migration-dev.ipws.mathworks.com/components/index.php?include=tabs&template=corporatenav&env=www&css=aem&theme=light#linked_to_separate_pages
document.addEventListener('DOMContentLoaded', function () {
    function getMobileContainer () {
        return document.querySelector('.borderless_tab_container.d-block.d-lg-none');
    }

    function syncDropdownToggleFromActive () {
        const mobileContainer = getMobileContainer();
        if (!mobileContainer) return;

        // Active dropdown item inside the mobile tab container
        const activeDropdownItem = mobileContainer.querySelector(
            '.dropdown-menu .dropdown-item.active'
        );
        if (!activeDropdownItem) return;

        const dropdown = activeDropdownItem.closest('.dropdown');
        if (!dropdown) return;

        const toggle = dropdown.querySelector('.dropdown-toggle');
        if (!toggle) return;

        // Copy icon + text into the toggle button
        toggle.innerHTML = activeDropdownItem.innerHTML;
    }

    // Sync active state across all tab triggers with same data-bs-target
    document.addEventListener('shown.bs.tab', function (event) {
        const targetSelector = event.target.getAttribute('data-bs-target');
        if (!targetSelector) return;

        // All tab triggers (desktop + mobile) that point at this tab pane
        const allTabTriggers = document.querySelectorAll(
            '[data-bs-toggle="tab"][data-bs-target="' + targetSelector + '"]'
        );

        allTabTriggers.forEach(function (trigger) {
            const tablist = trigger.closest('[role="tablist"]');
            if (!tablist) return;

            // Clear active state in this tablist
            tablist.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (btn) {
                btn.classList.remove('active');
                btn.setAttribute('aria-selected', 'false');
            });

            // Activate this trigger
            trigger.classList.add('active');
            trigger.setAttribute('aria-selected', 'true');
        });

        // Update the mobile dropdown toggle label/icon
        syncDropdownToggleFromActive();
    });

    // On initial load, make the mobile toggle show the current active tab
    syncDropdownToggleFromActive();
});
